module.exports = __webpack_public_path__ + "img/pump-sm.5591a003.svg";